const config = {
    host: process.env.NODE_ENV === 'development' ? 'http://localhost:3009' : 'https://dot12.cn/ablum',
    baseUrl: 'https://dot12.cn/apis',
    // baseUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:3300' : 'https://dot12.cn/apis',
    appId: 'wx4cf8145a5244661d',
    appSecret: '7a1918fd5f2ff2dcd7335fb928033619',
    openAppId: 'wxb456d01fb036c58a'
}

export default config